export default __webpack_public_path__ + "static/media/phd.a68c1309.svg";